import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { BoxExplorer } from "react-box-explorer";
import { useIntercom } from "react-use-intercom";

import "react-box-explorer/style.css";

import { getBoxBaseUrlsFromSearch } from "~/hooks";

const ContentExplorer = () => {
  const location = useLocation();
  const { shutdown } = useIntercom();
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    shutdown();
  }, []);

  const machineId = queryParams.get("machineId");
  const machineName = queryParams.get("machineName");
  const folderAccessToken = queryParams.get("folderAccessToken");
  const templateFolderAccessToken = queryParams.get(
    "templateFolderAccessToken",
  );
  const folderId = queryParams.get("folderId");
  const templateFolderId = queryParams.get("templateFolderId");

  // This page renders outside the auth guard, so the proxy flag travels in the
  // URL rather than coming off the signed-in OEM.
  const boxBaseUrls = getBoxBaseUrlsFromSearch(location.search);

  return (
    <BoxExplorer
      {...boxBaseUrls}
      className="h-full"
      entityName={machineName}
      fullScreenPreview
      height="100vh"
      folders={[
        ...(folderId
          ? [
              {
                folderId,
                token: folderAccessToken,
                canUpload: false,
                canCreateFolder: false,
                canPreview: true,
                canDownload: false,
                canDelete: false,
                canRename: false,
              },
            ]
          : []),
        ...(templateFolderId
          ? [
              {
                folderId: templateFolderId,
                token: templateFolderAccessToken ?? folderAccessToken,
                canUpload: false,
                canCreateFolder: false,
                canPreview: true,
                canDownload: false,
                canDelete: false,
                canRename: false,
              },
            ]
          : []),
      ]}
    />
  );
};

export default ContentExplorer;
